import React from 'react';
import { useLocation } from "react-router-dom";
import { translate } from 'react-i18next';
//import FontAwesome from 'react-fontawesome';
// import * as CardComponents from '../../../Common/CardComponents';
import {getQueryParam, makeRoute, transformFollowersCount} from '../../../../helpers';
import {gtmSend} from '../../../../helpers';
import cx from '../../../../styles';

const FeedSwitcher = ({trendingTopicsElems=[],appReducer}) => {
    const location = useLocation()
    const lng = getQueryParam(location, 'lng');
    
    /*let defaultElems = [
        <Link to='/feed/latest' className={cx('pointer-click')}>{t('community_tab_latest')}</Link>,
        <Link to='/feed/popular' className={cx('pointer-click')}>{t('community_tab_trending')}</Link>
    ];*/
    // let finalFeedElems = [...defaultElems, ...feedElems];

    return (
        <div className={cx("shadow-card", "feed-switcher")}>
            {/*<div>{t('menu_feed')}</div>
            <ul>
                {
                    finalFeedElems.map((elem, i) => {
                        return <li key={i}>{elem}</li>;
                    })
                }
            </ul>*/}

            <div className={`trending-topics-list`}>
                {
                    trendingTopicsElems && trendingTopicsElems.length !== 0 &&
                    trendingTopicsElems.map((topic, i) => {
                        return (
                            <div key={i} className={`trending-topics`}>
                                <a href={makeRoute(`/topic/${topic.slug}`,appReducer)} onClick={()=>gtmSend('cw_trending_topic_click', 'Topics', `${topic.name}`, `${window.location}`, 0)}>
                                    <img src={topic.image ? topic.image : ""} alt={topic.name} loading="lazy"/>

                                    <span>
                                        <b>{topic.name}</b>
                                        <label>{transformFollowersCount(topic.total_members, lng)}</label>
                                    </span>
                                </a>
                            </div>
                        )
                    })
                }
            </div>

            {/*<div>{t('community_tab_trending') + ' ' + t('community_tab_topic')}</div>
            <ul>
                {
                    trendingTopicsElems.map((topic, i) => {
                        return <li key={i}>
                            <Link to={makeRoute(`/topic/${topic.slug}`,appReducer)} className={cx('pointer-click')}>{topic.name}</Link>
                        </li>;
                    })
                }
            </ul>*/}
        </div>
    );
}

export default translate()(FeedSwitcher);
